module.exports = __webpack_public_path__ + "static/media/40x40-10.afda5663.png";